<template>
  <div>
    <el-dialog
      title="书库信息查询"
      :visible="showLibrary"
      @close="closeLibraryDialog"
      @open="open"
      width="1200px"
      center
    >
      <div class="user-libraryDialog-header">
        <div></div>
        <div class="user-libraryDialog-header-right">
          <!-- <el-select v-model="librarySearchType">
            <el-option key="title" label="文件名" value="title"></el-option>
            <el-option key="parent" label="父目录" value="parent"></el-option>
          </el-select> -->
          <List-search
            ref="librarySearch"
            @listSearchEvn="librarySearchEvn"
            @clearSearch="clearLibrarySearch"
          />
          <button class="global-button-style" @click="getLibrary">更新</button>
        </div>
      </div>
      <div class="user-libraryDialog-main" v-loading="loading">
        <div class="global-body-wrap">
          <TableData
            ref="libraryTable"
            :tableProps="libraryProps"
            :tableData="limitData"
            :sortable="['name', 'createdAt', 'updatedAt']"
            :tableBtn="libraryBtn"
            :currentPage="libraryPage"
            :pageSize="libraryLimit"
            @tableSortOrder="libraryTableSortOrder"
            @tableHandle="tableHandle"
          />
        </div>
        <Pagination
          :pageSize="libraryLimit"
          :total="metadataLength"
          :currentPage="libraryPage"
          @pageNum="libraryPageNum"
        />
      </div>
    </el-dialog>

    <el-dialog :title="'详情'" :visible.sync="showLibraryDetails">
      <div v-loading="libraryDetailsLoading">
        <template v-if="currentLibraryItem">
          <div class="libraryDetailsDialog-item">
            <div class="global-body-wrap">
              <TableData
                v-if="checkType === 'annotation'"
                :tableProps="annotationProps"
                :tableData="currentLibraryItem.annotation"
              />
              <TableData
                v-if="checkType === 'bookMark'"
                :tableProps="bookMarkProps"
                :tableData="currentLibraryItem.bookMark"
              />
            </div>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListSearch from '@/components/listSearch'
import Pagination from '@/components/pagination'
import TableData from '../tableData'
import syncUtils from '@/syncUtils'

export default {
  props: {
    showLibrary: {
      type: Boolean,
      default: false
    },
    userItem: {
      type: Object
    }
  },
  components: {
    ListSearch,
    TableData,
    Pagination
  },
  computed: {
    libraryProps() {
      return [
        {
          prop: 'uniqueId',
          label: 'UniqueId'
        },
        // {
        //   prop: 'name',
        //   label: '书名'
        // },
        // {
        //   prop: 'size',
        //   label: '大小',
        //   width: 100
        // },
        // {
        //   prop: 'authors',
        //   label: '作者',
        //   width: 100
        // },
        // {
        //   prop: 'type',
        //   label: '格式',
        //   width: 70
        // },
        {
          prop: 'annotationCount',
          label: '批注数量',
          width: 70
        },
        {
          prop: 'bookMarkCount',
          label: '书签数量',
          width: 70
        },
        // {
        //   prop: 'idString',
        //   label: 'idString'
        // },
        {
          prop: 'createdAt',
          label: '创建时间'
        },
        {
          prop: 'updatedAt',
          label: '更新时间'
        }
      ]
    },
    libraryBtn() {
      return [
        // { label: '查看批注', type: 'checkAnnotation' },
        // { label: '查看书签', type: 'checkBookMark' }
      ]
    },
    annotationProps() {
      return [
        {
          prop: 'note',
          label: '批注内容'
        },
        {
          prop: 'quote',
          label: '书籍内容'
        },
        {
          prop: 'pageNumber',
          label: '页码',
          width: 80
        },
        {
          prop: 'createdAt',
          label: '创建时间',
          width: 140
        },

        {
          prop: 'updatedAt',
          label: '更新时间',
          width: 140
        }
      ]
    },
    bookMarkProps() {
      return [
        {
          prop: 'quote',
          label: '书签内容'
        },
        {
          prop: 'pageNumber',
          label: '页码',
          width: 80
        },
        {
          prop: 'createdAt',
          label: '创建时间',
          width: 140
        },

        {
          prop: 'updatedAt',
          label: '更新时间',
          width: 140
        }
      ]
    }
  },
  data() {
    return {
      sortType: 'updatedAt',
      orderType: 'descending',
      originData: {},
      libraryData: [],
      libraryPage: 1,
      libraryLimit: 20,
      metadataLength: 0,
      librarySearch: '',
      librarySearchType: 'uniqueId',
      loading: false,
      currentLibraryItem: null,
      currentLibraryPageId: '',
      showLibraryDetails: false,
      libraryDetailsLoading: false,
      limitData: [],
      searchData: [],
      checkType: ''
    }
  },
  methods: {
    open() {
      this.getLibrary()
    },
    initLibraryData() {
      this.limitData = []
      this.librarySearch = ''
      this.libraryPage = 1
      this.$refs.libraryTable ? this.$refs.libraryTable.clearSort() : null
      this.$refs.librarySearch ? this.$refs.librarySearch.clearValue() : null
    },

    async getLibrary() {
      this.initLibraryData()
      this.loading = true

      await this.clearDB()
      let res = await this.$http.getSyncToken({ userId: this.userItem.id })

      await this.updateSyncChannels([`${this.userItem.uid}-READER_LIBRARY`])

      this.$cookie.set(res.data.cookie_name, res.data.session_id)
      this.pullNotes(this.userItem.uid)
    },

    async updateSyncChannels(rootChannel) {
      const channls = {
        action: 'add',
        userId: this.userItem.id,
        channels: rootChannel
      }
      return this.$http.updateSyncChannels(channls)
    },
    async clearDB() {
      return new Promise(async (resolve, reject) => {
        try {
          let r = await indexedDB.databases()
          for (let i of r) {
            indexedDB.deleteDatabase(i.name)
          }
          // this.$cookie.remove("SyncGatewaySession");
          resolve('ok')
        } catch (error) {
          reject(error)
        }
      })
    },

    async pullNotes(uid) {
      let opts = {
        dbName: `${uid}-READER_LIBRARY`,
        channels: `${uid}-READER_LIBRARY`
      }
      await syncUtils.pull(opts)
      this.originData = await syncUtils.getLibraryChannel(opts)
      this.metadata = this.originData.metadata
      for (let item of this.metadata) {
        this.pullAnnotationAndBookMark(item)
      }
      this.cuttingLibraryData()
      this.loading = false
    },

    async tableHandle(obj) {
      if (obj.type === 'checkAnnotation') {
        this.checkType = 'annotation'
        this.currentLibraryItem = obj.data.row
        this.showLibraryDetails = true
      } else if (obj.type === 'checkBookMark') {
        // obj.data.row.shapeLoading = true;
        this.checkType = 'bookMark'
        this.currentLibraryItem = obj.data.row
        this.showLibraryDetails = true
      }
    },

    async getUserOssData() {
      try {
        let params = {
          userId: this.userItem.id,
          dir: 'point'
        }
        let res = await this.$http.checkOssInfo(params)
        return res.data
      } catch (error) {
        throw new Error(error)
      }
    },

    async pullAnnotationAndBookMark(item) {
      try {
        let annotation = this.originData.annotation.filter(
          (data) => data.documentId === item.uniqueId
        )
        let bookMark = this.originData.bookMark.filter(
          (data) => data.documentId === item.uniqueId
        )
        this.$set(item, 'annotationCount', annotation.length)
        this.$set(item, 'annotation', annotation)
        this.$set(item, 'bookMarkCount', bookMark.length)
        this.$set(item, 'bookMark', bookMark)
        item.shapeLoading = false
        return item
      } catch (error) {
        item.shapeLoading = false
        throw new Error(error)
      }
    },
    libraryPageNum(page) {
      this.libraryPage = page
      this.librarySearch
        ? this.cuttingLibrarySearchData()
        : this.cuttingLibraryData()
    },
    closeLibraryDialog() {
      this.loading = false
      this.$emit('close')
    },
    librarySearchEvn(val) {
      this.librarySearch = val
      this.libraryPage = 1
      if (val) {
        this.searchData = this.metadata.filter((item) =>
          this.librarySearchType === 'uniqueId'
            ? item.uniqueId && item.uniqueId.indexOf(val) !== -1
            : item.parentTitle && item.parentTitle.indexOf(val) !== -1
        )
        this.cuttingLibrarySearchData()
      } else {
        this.clearLibrarySearch()
      }
      this.libraryTableSortOrder({
        prop: this.sortType,
        order: this.orderType
      })
    },
    clearLibrarySearch() {
      this.librarySearch = ''
      this.libraryPage = 1
      this.cuttingLibraryData()
    },

    cuttingLibraryData() {
      this.metadataLength = this.metadata.length
      this.limitData = this.metadata.slice(
        (this.libraryPage - 1) * this.libraryLimit,
        this.libraryPage * this.libraryLimit
      )
    },

    cuttingLibrarySearchData() {
      this.limitData = this.searchData.slice(
        (this.libraryPage - 1) * this.libraryLimit,
        this.libraryPage * this.libraryLimit
      )
      this.metadataLength = this.searchData.length
    },

    libraryTableSortOrder({ prop, order }) {
      if (order) {
        this.sortType = prop
        this.orderType = order
      } else {
        this.sortType = 'updatedAt'
        this.orderType = 'descending'
      }

      if (this.librarySearch) {
        this.searchData = this.$_.orderBy(
          this.searchData,
          this.sortType,
          this.orderType === 'ascending' ? 'asc' : 'desc'
        )
        this.cuttingLibrarySearchData()
      } else {
        this.metadata = this.$_.orderBy(
          this.metadata,
          this.sortType,
          this.orderType === 'ascending' ? 'asc' : 'desc'
        )
        this.cuttingLibraryData()
      }
    }
  }
}
</script>

<style lang="scss">
.user-libraryDialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-libraryDialog-header-right {
    display: flex;
    align-items: center;
    > .el-select {
      width: 100px;
    }
    > button {
      margin-top: 0;
      margin-left: 20px;
    }
  }
}
.user-libraryDialog-main {
  margin-top: 20px;
}
.libraryDetailsDialog-item + .libraryDetailsDialog-item {
  margin-top: 20px;
}
.libraryDetailsDialog-item {
  display: flex;
  align-items: center;
}
</style>
